
import { useState, useEffect } from 'react';
import { useAccount } from 'wagmi';
import { testSupabaseConnection } from '@/lib/supabase';
import { isMobile } from '@/lib/utils';
import InitiationContent from './InitiationContent';
import MobileNav from '../MobileNav';

const InitiationPage = () => {
  const { address, isConnected } = useAccount();
  const [supabaseReady, setSupabaseReady] = useState<boolean | null>(null);
  const [connectionError, setConnectionError] = useState<string | null>(null);
  const [showDebug, setShowDebug] = useState<boolean>(false);
  const [mobileDetected, setMobileDetected] = useState<boolean>(false);
  
  // Detect mobile device on mount
  useEffect(() => {
    const onMobile = isMobile();
    setMobileDetected(onMobile);
    
    if (onMobile) {
      console.log('Mobile device detected, adjusting wallet connection behavior');
    }
  }, []);
  
  // Test Supabase connection on mount
  useEffect(() => {
    const checkSupabaseConnection = async () => {
      console.log('🧪 Testing Supabase connection from Initiation page...');
      try {
        const isConnected = await testSupabaseConnection();
        console.log('🔌 Supabase connection test result:', isConnected);
        setSupabaseReady(isConnected);
        
        if (!isConnected) {
          setConnectionError('Could not connect to Supabase. Please try again later.');
        }
      } catch (error) {
        console.error('🛑 Supabase connection test error:', error);
        setSupabaseReady(false);
        setConnectionError(`Connection error: ${(error as Error).message}`);
      }
    };
    
    checkSupabaseConnection();
    
    // Check for debug mode via keyboard shortcut
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+Shift+D to toggle debug mode
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        setShowDebug(prev => !prev);
        console.log('Debug mode toggled:', !showDebug);
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showDebug]);
  
  return (
    <>
      {mobileDetected && <MobileNav />}
      <InitiationContent 
        address={address}
        isConnected={isConnected}
        supabaseReady={supabaseReady}
        connectionError={connectionError}
        showDebug={showDebug}
        mobileDetected={mobileDetected}
      />
    </>
  );
};

export default InitiationPage;
